import * as React from "react"
import { SVGProps } from "react"
const IconRedDanger = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={23}
        height={20}
        fill="none"
        {...props}
    >
        <g fill="red" clipPath="url(#a)">
            <path d="M10.921 14.255a.632.632 0 0 0 .399.589.653.653 0 0 0 .247.049v.893a.987.987 0 0 0-.64.31.963.963 0 0 0 0 1.314c.166.179.395.29.64.31v1.296H1.292a.292.292 0 0 1-.253-.139.302.302 0 0 1 0-.284L11.23 1.13a.286.286 0 0 1 .498 0l2.703 4.615-1.797 1.032a1.282 1.282 0 0 0-.692-.518 1.3 1.3 0 0 0-.868.034c-.276.111-.505.313-.647.572a1.255 1.255 0 0 0-.13.848l.624 6.542Z" />
            <path d="M21.962 18.593a.268.268 0 0 1 0 .284.287.287 0 0 1-.253.139H11.567V17.72a.994.994 0 0 0 .748-.252.97.97 0 0 0 .318-.715.96.96 0 0 0-.318-.714.986.986 0 0 0-.748-.253v-.893a.65.65 0 0 0 .457-.187.633.633 0 0 0 .189-.451l.624-6.542a1.266 1.266 0 0 0 0-.229 1.278 1.278 0 0 0-.217-.693l1.81-1.032 7.532 12.834Z" />
            <path d="M22.825 18.101a1.256 1.256 0 0 1-.47 1.728c-.194.11-.415.17-.64.171H1.292c-.225 0-.446-.058-.642-.169a1.277 1.277 0 0 1-.47-.463 1.256 1.256 0 0 1-.004-1.267L10.388.638c.11-.198.274-.363.471-.478a1.297 1.297 0 0 1 1.774.478L22.825 18.1Zm-.864.776a.268.268 0 0 0 0-.284l-7.51-12.848L11.75 1.13a.279.279 0 0 0-.245-.146.29.29 0 0 0-.253.146L1.039 18.593a.302.302 0 0 0 0 .284.286.286 0 0 0 .252.139H21.71a.29.29 0 0 0 .252-.139Z" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h23v20H0z" />
            </clipPath>
        </defs>
    </svg>
)
export default IconRedDanger;
